import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { firebase } from '../../../../services/firebase';
import { SHOP_TYPES } from '../constant';

export const useBusinessServices = (user) => {
  const [shopType, setShopType] = useState({});
  const [businessAtAGlance, setBusinessAtAGlance] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBusinessServices = async () => {
      if (!user) return;

      try {
        setLoading(true);
        setError(null);
        
        // Fetch business data from businesses/{user.uid}
        const businessRef = doc(firebase, 'businesses', user.uid);
        const businessDoc = await getDoc(businessRef);

        const atAGlanceRef = doc(firebase, 'businessAtAGlance', user.uid);
        const atAGlanceDoc = await getDoc(atAGlanceRef);

        if (businessDoc.exists()) {
          const businessData = businessDoc.data();
          const shopTypeData = businessData.shopType || {};
          
          setShopType(shopTypeData);
        }

        if (atAGlanceDoc.exists()) {
          setBusinessAtAGlance(atAGlanceDoc.data());
        }
      } catch (err) {
        console.error('Error fetching business data:', err);
        setError('Failed to fetch business data');
      } finally {
        setLoading(false);
      }
    };

    fetchBusinessServices();
  }, [user]);

  return {
    shopType,
    businessAtAGlance,
    loading,
    error,
    // Helper function to get services for a specific shop type
    getServicesByType: (shopType) => {
      if (!shopType) return {};
      const category = SHOP_TYPES.find(
        cat => cat.items?.some(item => item.value === shopType)
      );
      return category || {};
    }
  };
};
